import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppointmentService } from '../../business-services/appointment.service';
import { OnHoldReasonList } from '../../business-entities/onHold-reason-list-model';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import * as Enums from '../../../../../Autofacets-Core/src/app/utils/enums';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Features } from '../../business-entities/user-role-view-model';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';


@Component({
  selector: 'app-delete-workorder',
  templateUrl: './delete-workorder.component.html'
  
})
export class DeleteWorkorderComponent implements OnInit {
  @Input() licensePlate: string;
  @Input() appointmentId: number;
  @Input() workOrderNumber: string;
  @Input() isDeleteFromDms: boolean=false;
  @Input() appointmentGuid: any;
  onHoldStatusReasonList: OnHoldReasonList[];
  selectedReasonId: number;
  features: Features[] = [];
  constructor(
    private activeModal: NgbActiveModal,
    private appointmentService: AppointmentService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private cookieservice: CookieService,
    private spinner: NgxSpinnerService,
    private secureStorage: SecureStorage,
  ) { }

  ngOnInit(): void {
    this.getReasonList();
  }

  getReasonList() {
    let langCode=this.cookieservice.get('userSelectedLanguage')
    this.appointmentService.GetOnHoldStatusReasonList(langCode,Enums.ReasonType.Delete).then(data => {
      let response = data.responseObject
      if (response?.errorCount === 1) {
        this.onHoldStatusReasonList = [];
      }
      else {
        this.onHoldStatusReasonList = this.onHoldStatusReasonListDataMapper(data.responseObject);
      }
    }
    )
  }
  private onHoldStatusReasonListDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {
      for (let index = 0; index < List.length; index++) {
        const element = List[index];
        let single = Object();
        single.rowNumber = 1 + index;
        single.reasonId=element.reasonId;
        single.reason = element.reason;
        single.isDescriptionRequire = element.isDescriptionRequire;
        single.isSelected = false;
        single.description = null;
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  reasonCheckboxChange(reasonId: number,index:number,isSelected:boolean) {
    if(isSelected)
    {
      this.selectedReasonId = reasonId;
      this.onHoldStatusReasonList.forEach((x, _i) => {
        if (x.reasonId !== reasonId) {
          x.isSelected = false;
        }
      });
      this.onHoldStatusReasonList[index].isSelected = true;
    }
    else
    {
      this.selectedReasonId=null;
    }
  }
  onCrossClickModel() {
    this.activeModal.close({
      success: false,
    });
  }

  submiteOnDeleteDetails() {
    this.spinner.show();
    let errorMsg = this.translate.instant("lblDescriptionRequire");
    let selectedReason=this.onHoldStatusReasonList.filter(x=>x.reasonId===this.selectedReasonId)[0];
    if (selectedReason.isDescriptionRequire && !selectedReason.description) {
      this.toaster.error(errorMsg);
      this.spinner.hide();
    }
    else
    {
      let deleteModel ={
          appointmentId : this.appointmentId,
          workOrderNo : this.workOrderNumber,
          licensePlate : this.licensePlate,
          userId : "",
          isDeleteFromDms : this.isDeleteFromDms,
          appointmentGuid : this.appointmentGuid,
          reasonForDeletion : selectedReason.isDescriptionRequire ? selectedReason.description :selectedReason.reason,
        }
        this.appointmentService.DeleteAppointment(deleteModel).then((response) => {
          if (response.isSuccess === true) {
            let successMsg = this.translate.instant("lblAppointmentDeleted");
            this.toaster.success(successMsg);
            this.activeModal.close({
              success: true
            });
          }
          else {
            let errorMsg = this.translate.instant("lblAppointmentNotDeleted");
            if(response.resultMessage != null && response.resultMessage != undefined && response.resultMessage != ""){
              errorMsg = response.resultMessage;
            };
            this.toaster.error(errorMsg);
          }
          this.spinner.hide();
        });
    }
  }
}
